import { forwardRef, type SVGAttributes } from 'react';

const AudioGuideIcon = forwardRef<SVGSVGElement, SVGAttributes<SVGSVGElement>>(
  ({ className, fill = 'white', ...props }, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill={fill}
        className={className}
        {...props}
      >
        <path
          fill={fill}
          d="M9.448 2c3.337 0 4.73 2.54 4.534 3.78-.195 1.24-1.244 3.544-2.188 4.263-.63.479-.923 1.184-.88 2.117C10.21 13.387 9.289 14 8.152 14c-1.706 0-2.994-1.134-2.591-3.638.268-1.67.193-3.134-.226-4.392C5.85 3.323 7.223 2 9.447 2ZM2.782 5.447a.392.392 0 0 1 .553.001 4.53 4.53 0 0 1 1.332 3.22 4.53 4.53 0 0 1-1.332 3.218.391.391 0 0 1-.554-.554 3.752 3.752 0 0 0 1.103-2.665 3.752 3.752 0 0 0-1.103-2.666.391.391 0 0 1 0-.554ZM1.439 6.78a.34.34 0 0 1 .507 0c.465.505.72 1.175.72 1.887s-.255 1.381-.72 1.886a.344.344 0 0 1-.254.114.345.345 0 0 1-.253-.114.412.412 0 0 1 0-.55c.329-.357.51-.832.51-1.336 0-.505-.181-.98-.51-1.337a.412.412 0 0 1 0-.55Zm8.244-2.447c-.605 0-1.174.184-1.601.517-.49.382-.749.919-.749 1.553v.687c0 .116.071.221.183.274a.366.366 0 0 0 .35-.022c.215-.139.654-.342.926-.297a.255.255 0 0 1 .178.108c.07.096.089.183.058.284-.112.372-.82.796-1.24.976-.169.072-.242.255-.163.41.058.111.18.177.306.177.048 0 .097-.01.143-.03.14-.059 1.373-.604 1.605-1.369a.87.87 0 0 0-.15-.793.941.941 0 0 0-.618-.37c-.308-.05-.637.03-.902.133v-.168c0-.998.868-1.453 1.674-1.453.817 0 1.642.449 1.642 1.453 0 .17.15.308.337.308.187 0 .338-.138.338-.308 0-1.359-1.165-2.07-2.317-2.07Z"
        />
      </svg>
    );
  }
);

AudioGuideIcon.displayName = 'AudioGuideIcon';
export default AudioGuideIcon;
